import React from 'react';
import { IconProps } from './icon';

export default function BaseSvg(props: IconProps): React.ReactElement {
  const {
    id,
    children,
    description,
    dmId,
    fill,
    pointerEvents = 'none',
    size,
    title,
    viewBox,
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  // Accessibility attributes
  const uniqueId = id || dmId; // todo: dmId should be removed, as soon as id prop is required (myt-7757)
  const TITLE_ID = `${uniqueId}Title`;
  const DESC_ID = description ? `${uniqueId}Desc` : '';
  const ARIA_LABELLEDBY = `${TITLE_ID} ${DESC_ID}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-dmid={dmId}
      viewBox={viewBox}
      width={size}
      height={size}
      role="img"
      aria-labelledby={ARIA_LABELLEDBY}
      fill={fill}
      pointerEvents={pointerEvents}
      {...otherProps}>
      <title id={TITLE_ID}>{title}</title>
      {description && <desc id={DESC_ID}>{description}</desc>}
      {children}
    </svg>
  );
}
